module.exports = __webpack_public_path__ + "static/img/budgetImg@4x.85d7f401.png";